const item = "dibiwzdfq1";

export { item };
import "./item.style.linaria.module.css";
//# sourceMappingURL=item.style.js.map
